import { authAxios } from "services";

export const fetchAll = (page) => authAxios().get(`/cities?page=${page}`);

export const fetchOptions = () => authAxios().get(`/cities/options`);

export const create = (data) => authAxios().post(`/cities`, data);

export const fetchById = (id) => authAxios().get(`/cities/${id}`);

export const deleteById = (id) => authAxios().delete(`/cities/${id}`);

export const updateById = (id, data) => authAxios().post(`/cities/${id}?_method=PUT`, data);
